import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('app', () => {
  const isMobile = ref(false)
  const isWeb = ref(true)
  const innerWidth = ref(window.innerWidth)

  const isDesktopWidth = computed(() => {
    return innerWidth.value >= 1024
  })

  const popoverCounter = ref(0)

  return {
    isMobile,
    isWeb,
    innerWidth,
    isDesktopWidth,
    popoverCounter,
  }
})
